import NavLinkUndecorated from "components/common/style/link/NavLinkUndecorated";
import styled from "styled-components";

export const ChannelMessageNavLink = styled(NavLinkUndecorated)`
  margin-left: 2rem;
  font-size: 0.75rem;
`;
